/**
 * Интерактивных полей ввода, которые нуждаются в префиксах/суффиксах компонента <Input />,
 * но сделаны на основе другого компонента (например Select)
 */

import React, { FunctionComponent } from 'react'
import cn from 'classnames'
import styles from './InteractiveInput.less'

export interface InteractiveInputProps {
    suffixClassName?: string
    suffix?: React.ReactNode
    children: React.ReactNode
    onSuffixClick?: () => void
}

/**
 *
 * @param props
 * @category Components
 */
const InteractiveInput: FunctionComponent<InteractiveInputProps> = props => {
    return (
        <div className={styles.container}>
            {props.children}
            {props.suffix && (
                <button className={cn(styles.button, styles.suffix, props.suffixClassName)} onClick={props.onSuffixClick}>
                    {props.suffix}
                </button>
            )}
        </div>
    )
}

export default React.memo(InteractiveInput)
